module.exports = __webpack_public_path__ + "img/status_progress.b32627dc.svg";